import {StringHelper} from "./stringHelper";

export default {
  filters: Object.assign({}, StringHelper)
};